import { render } from "./LogoutDialog.vue?vue&type=template&id=4b1ef0b2&scoped=true"
import script from "./LogoutDialog.vue?vue&type=script&lang=js"
export * from "./LogoutDialog.vue?vue&type=script&lang=js"

import "./LogoutDialog.vue?vue&type=style&index=0&id=4b1ef0b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1ef0b2"]])

export default __exports__